import React, { useRef, useEffect, useState } from 'react';
import { Link } from 'react-router-dom';

function SectionHeader({ title, linkTo = "/cv", linkLabel = "CV" }) {
  const sentinelRef = useRef(null);
  const [isStuck, setIsStuck] = useState(false);

  useEffect(() => {
    const sentinel = sentinelRef.current;
    if (!sentinel) return;

    const observer = new IntersectionObserver(
      ([entry]) => setIsStuck(!entry.isIntersecting),
      { threshold: 0 }
    );

    observer.observe(sentinel);
    return () => observer.disconnect();
  }, []);

  return (
    <>
      <div ref={sentinelRef} className="section-sentinel" />
      <div className={`section-header ${isStuck ? 'is-stuck' : ''}`}>
        <div className="section-header-container">
          <h2 className="section-header-title">{title}</h2>
          <nav className="section-nav-mobile">
            <Link to={linkTo}>{linkLabel}</Link>
          </nav>
        </div>
      </div>
    </>
  );
}

export default SectionHeader;
